import { domain as configDomain, PRICE_PER_HOUR } from '../config';
export { PRICE_PER_HOUR };

export const WD_RU = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
export const WD_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const MON_RU = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
export const MON_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const WD = WD_RU;
export const MON = MON_RU;
export const MAX_HOURS = 12;
export const TIERS = [
  { from: 0, price: PRICE_PER_HOUR, rangeKey: 'tier_range_up_to_50', noteKey: 'tier_note_hourly', range: 'до $50', note: 'за час' },
  { from: 50, price: 8, rangeKey: 'tier_range_from_50', noteKey: 'tier_percent_20', range: 'от $50', note: '+20%' },
  { from: 200, price: 7, rangeKey: 'tier_range_from_200', noteKey: 'tier_percent_30', range: 'от $200', note: '+30%' },
];

export const priceForTopup = (a) => {
  const tier = [...TIERS].reverse().find((t) => a >= t.from);
  return tier ? tier.price : PRICE_PER_HOUR;
};

export function localDate(d) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export function parseLocal(dateStr, hour) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d, hour);
}

export const pad = (h) => String(((h % 24) + 24) % 24).padStart(2, '0') + ':00';
export const money = (n) => '$' + Number(n || 0).toFixed(2);
export const fmtTime = (d) => String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');

export const fmtDate = (iso, lang = 'ru') => {
  const d = new Date(iso);
  const today = localDate(new Date());
  const tm = new Date();
  tm.setDate(tm.getDate() + 1);
  const mon = lang === 'en' ? MON_EN : MON_RU;
  if (localDate(d) === localDate(tm)) return lang === 'en' ? 'Tomorrow' : 'Завтра';
  if (localDate(d) === today) return lang === 'en' ? 'Today' : 'Сегодня';
  return d.getDate() + ' ' + mon[d.getMonth()] + (d.getFullYear() !== new Date().getFullYear() ? ' ' + d.getFullYear() : '');
};

export const until = (ms, lang = 'ru') => {
  const m = Math.max(0, Math.round(ms / 60e3));
  const h = Math.floor(m / 60);
  const hUnit = lang === 'en' ? 'h' : 'ч';
  const mUnit = lang === 'en' ? 'min' : 'мин';
  return (h ? `${h} ${hUnit} ` : '') + (m % 60) + ` ${mUnit}`;
};

export const days = (count = 30) => Array.from({ length: count }, (_, i) => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + i);
  return d;
});

const getInitData = () => {
  if (typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp) {
    return window.Telegram.WebApp.initData || '';
  }
  return '';
};

const API_BASE = configDomain || '';
const tz = typeof Intl !== 'undefined' ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC';

async function http(method, path, body) {
  const initData = getInitData();
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Telegram-Init-Data': initData,
      'authorization': initData,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.detail || 'Ошибка сервера');
    err.status = res.status;
    err.code = data.code;
    throw err;
  }
  return data;
}

export const api = {
  async me() {
    const userRes = await http('GET', '/user');
    const user = userRes.user || {};
    const balance = parseFloat(user.balance || 0);
    return {
      id: user.id,
      user_id: user.id,
      username: user.username,
      language_code: user.language_code || 'ru',
      language: user.language_code || 'ru',
      first_seen: user.created_at ? user.created_at.split('T')[0] : '',
      balance: balance,
      recent_models: userRes.recent_models || [],
      onboarded: true,
    };
  },

  async slots(date) {
    const seatsRes = await http('POST', '/check-seats', { date });
    const busySet = new Set();
    if (seatsRes && seatsRes.availableSeats) {
      seatsRes.availableSeats.forEach(item => {
        if (item.seats <= 0) busySet.add(item.hour);
      });
    }
    const minStart = Date.now() + 15 * 60e3;
    const hours = [];
    for (let h = 0; h < 24; h++) {
      const t = parseLocal(date, h).getTime();
      hours.push({
        hour: h,
        status: t < minStart ? 'past' : (busySet.has(h) ? 'busy' : 'free')
      });
    }
    return { date, tz, hours };
  },

  async createOrder({ model, start, hours, remind }) {
    await http('POST', '/new-order', {
      streamer_id: model,
      start_date: start,
      work_time: hours
    });
    const me = await api.me();
    return {
      order: {
        id: Date.now(),
        model,
        start,
        hours,
        cost: hours * PRICE_PER_HOUR,
        status: 'scheduled',
        remind: remind ?? true
      },
      balance: me.balance
    };
  },

  async orders(scope) {
    const res = await http('GET', '/my-orders?per_page=100');
    const orderDict = res.Orders || {};
    const list = Object.values(orderDict).map(o => {
      const hours = o.task_work ? Math.max(1, Math.round(o.task_work / 60)) : 1;
      const cost = hours * PRICE_PER_HOUR;
      return {
        id: o.task_id,
        model: o.streamer_id,
        start: o.start_time,
        hours: hours,
        cost: cost,
        status: o.deleted_at ? 'cancelled' : (o.status === 'active' ? 'running' : o.status === 'completed' ? 'done' : 'scheduled'),
        remind: true,
        refunded: o.deleted_at ? cost : null
      };
    });
    const up = (o) => o.status === 'scheduled' || o.status === 'running';
    return { orders: list.filter(o => scope === 'upcoming' ? up(o) : !up(o)) };
  },

  async cancelOrder(id) {
    const res = await http('DELETE', `/delete-order/${id}`);
    return {
      balance: res.balance,
      refunded: res.refunded,
    };
  },

  async setReminder(id, remind) {
    return { order: { id, remind } };
  },

  async transactions() {
    try {
      const res = await http('GET', '/my-orders?per_page=100');
      const orderDict = res.Orders || {};
      const txs = Object.values(orderDict).map(o => {
        const hours = o.task_work ? Math.max(1, Math.round(o.task_work / 60)) : 1;
        const cost = hours * PRICE_PER_HOUR;
        return {
          id: o.task_id,
          type: o.deleted_at ? 'refund' : 'order',
          title: o.deleted_at ? `Возврат · ${o.streamer_id}` : `Заказ · ${o.streamer_id}`,
          amount: o.deleted_at ? cost : -cost,
          at: o.deleted_at || o.start_time || new Date().toISOString()
        };
      });
      return { transactions: txs };
    } catch (e) {
      return { transactions: [] };
    }
  },

  async topup(amount) {
    return await http('POST', '/create-invoice', { amount });
  },

  async referral() {
    const res = await http('GET', '/user');
    return {
      link: res.ref_link || '',
      percent: 10,
      invited: res.referral_count || 0,
      earned: 0,
      referrals: (res.referrals || []).map(r => ({
        name: r.referred_user ? `@${r.referred_user.username || r.referred_user.id}` : 'User',
        earned: 0
      }))
    };
  }
};

export default api;
